import { render } from "./TktPass.vue?vue&type=template&id=02293e35&scoped=true"
import script from "./TktPass.vue?vue&type=script&lang=js"
export * from "./TktPass.vue?vue&type=script&lang=js"

import "./TktPass.vue?vue&type=style&index=0&id=02293e35&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02293e35"]])

export default __exports__